<template>
  <div class="pa-6 mt-0" style="width: 100%">
    <div class="mb-6">
      <div class="component-title">Xem điểm kiểm tra</div>
    </div>

    <v-card outlined class="pa-6 mb-6 elevation-0">
      <TeacherMarkExamFilter @onFilterChanged="onFilterChanged" />
    </v-card>

    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView />
    </div>
    <v-card v-else outlined class="elevation-0">
      <TeacherExamMark :query="query" :subject="subject" :room="room" :exam="exam" />
    </v-card>
  </div>
</template>
<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import TeacherMarkExamFilter from '../../modules/exam/TeacherMarkExamFilter.vue'
import TeacherExamMark from '../../modules/exam/TeacherExamMark.vue'

export default {
  components: {
    StudentBlankView,
    TeacherMarkExamFilter,
    TeacherExamMark
  },
  data() {
    return {
      action: {
        state: 'select'
      },
      subject: {},
      room: {},
      query: {},
      exam: {},
      type: null,
      grade: null
    }
  },
  computed: {},
  methods: {
    onFilterChanged(params, subject, room, exam) {
      this.action.state = 'filtered'
      this.query = params
      this.subject = subject
      this.room = room
      this.exam = exam
    }
  }
}
</script>

<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
